module.exports = {
  Typography: {
    DisplayLarge: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "96px",
      fontSize: "64px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    DisplayMedium: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "72px",
      fontSize: "48px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    DisplaySmall: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "54px",
      fontSize: "36px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    HeadingLarge: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "42px",
      fontSize: "28px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    HeadingMedium: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "36px",
      fontSize: "24px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    HeadingSmall: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "30px",
      fontSize: "20px",
      letterSpacing: "-0.5px",
      textDecoration: "none",
    },
    TextLargeBold: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "24px",
      fontSize: "16px",
      letterSpacing: "0px",
      textDecoration: "none",
    },
    TextLarge: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "24px",
      fontSize: "16px",
      letterSpacing: "0px",
      textDecoration: "none",
    },
    TextLargeLight: {
      fontFamily: "Rubik",
      fontWeight: 300,
      lineHeight: "24px",
      fontSize: "16px",
      letterSpacing: "0px",
      textDecoration: "none",
    },
    TextMediumBold: {
      fontFamily: "Rubik",
      fontWeight: 500,
      lineHeight: "20px",
      fontSize: "14px",
      letterSpacing: "0.1px",
      textDecoration: "none",
    },
    TextMedium: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "20px",
      fontSize: "14px",
      letterSpacing: "0.1px",
      textDecoration: "none",
    },
    TextMediumLink: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "20px",
      fontSize: "14px",
      letterSpacing: "0.1px",
      textDecoration: "underline",
    },
    TextMediumLight: {
      fontFamily: "Rubik",
      fontWeight: 300,
      lineHeight: "20px",
      fontSize: "14px",
      letterSpacing: "0.1px",
      textDecoration: "none",
    },
    TextMono: {
      fontFamily: "DM Mono",
      fontWeight: 300,
      lineHeight: "20px",
      fontSize: "14px",
      letterSpacing: "0px",
      textDecoration: "none",
    },
    TextSmall: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "18px",
      fontSize: "12px",
      letterSpacing: "0.15px",
      textDecoration: "none",
    },
    TextSmallLink: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "18px",
      fontSize: "12px",
      letterSpacing: "0.15px",
      textDecoration: "underline",
    },
    TextExtraSmall: {
      fontFamily: "Rubik",
      fontWeight: 400,
      lineHeight: "14px",
      fontSize: "10px",
      letterSpacing: "0.15px",
      textDecoration: "none",
    },
  },
};
